const initialFuelTax = [
    { value: 0, min: 0, max: 0 },
    { value: 2160, min: 251, max: 500 },
    { value: 2880, min: 501, max: 600 },
    { value: 4320, min: 601, max: 1200 },
    { value: 4800, min: 1201, max: 1800 },
    { value: 6180, min: 1801, max: 2400 },
    { value: 7200, min: 2401, max: 3000 },
    { value: 8640, min: 3001, max: 3600 },
    { value: 9810, min: 3601, max: 4200 },
    { value: 11220, min: 4201, max: 4800 },
    { value: 12180, min: 4801, max: 5400 },
    { value: 13080, min: 5401, max: 6000 },
    { value: 13950, min: 6001, max: 6600 },
    { value: 14910, min: 6601, max: 7200 },
    { value: 15720, min: 7201, max: 8000 },
];

export default initialFuelTax;
